import { createSelector } from '@reduxjs/toolkit';

const getAppState = (state) => state.app;

const getAPIStatus = createSelector(getAppState, (appState) => appState.apiStatus);

export default getAPIStatus;
